import React, { useEffect, useState } from 'react';
import '../../Assets/CSS/blog.css';
import img1 from '../../Assets/Images/Blog/img1.jpeg';
import { Icon } from '@iconify/react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Login from '../../components/auth/login/Login';

const Blogs = ({ isAuthenticated }) => {
    const [blogs, setBlogs] = useState([]);
      const [showLoginModal, setShowLoginModal] = useState(false);
    const Navigate = useNavigate();
    useEffect(() => {
        fetchBlogs();
    }, []);
       const handleCloseLogin = () => {
        // Close login modal
        setShowLoginModal(false);

    }
    const fetchBlogs = async (date) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/blog/allblogs`,
            )
            const data = await response.json();
            setBlogs(data);
            console.log(blogs);

        } catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
    };
    const handleBlogClick = (blogId) => {
    if (!isAuthenticated) {
            setShowLoginModal(true);
            return;
        }
        console.log("Clicked Blog ID:", blogId); // Debugging


        Navigate(`/blogdetail/${blogId}`);

    };

    const renderBlog = (blog) => (
        <div key={blog.blogId} className='col-lg-6 col-md-6 col-sm-12 mb-4   cursor-pointer'
            onClick={() => handleBlogClick(blog.blogId)}>
            <div className='blog-container'>
            <img src={blog.blogImage[0]} alt={`blog${blog.blogId}`} 
            className='img-fluid rounded-3 blog-Image cursor-pointer '/>
           <Icon icon="ri:focus-3-line" className='focus-icon '/>
            </div>
            <h1 className='blog-title pt-2'>{blog.blogTitle}</h1>
            <p className='desc text-white'>{blog.blogDescription.slice(0, 100)}<span>...</span></p>
        </div>
    );

    return (
        <section id='blog ' className='blogs-section'>
             {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}
 <div className='px-lg-5 px-3 mt-3'>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="fw-bold heading" style={{ fontFamily: 'play', color: '#FFFFFF',marginTop:'30px',marginBottom:'20px' }}>Blogs</h2>
                <Link to="/blogs" className="text-decoration-none fs-6">
                   <button className='see-all'>
                     See All
                    <Icon icon="iconamoon:arrow-right-2" className="ms-1" />
                   </button>
                </Link>
            </div>
            <div className='row mt-2'>
                {/* Main Blog Item */}
                {/* <div className='col-lg-6 col-12 mb-4'>
                    <img
                        src={img1}
                        alt='blog1'
                        className='img-fluid rounded-3 w-100'
                    />
                    <h1 className='blog-title pt-3' style={{ fontSize: '22px', fontWeight: '500' }}>
                        Top 5 Innovations in Modern Naval Warfare
                    </h1>
                    <p>
                        Explore the latest advancements in naval defense systems and technologies that are reshaping maritime warfare.
                        This article dives into cutting-edge radar systems, automated weaponry, and stealth capabilities that are
                        empowering naval forces across the globe.
                    </p>
                </div> */}
                {blogs.length > 0 && (
    <div
        className='col-lg-6 col-12 mb-4 cursor-pointer'
        onClick={() => handleBlogClick(blogs[0].blogId)}
    >
         <div className='blog-container'>
        <img
            src={blogs[0].blogImage[0]}
            alt={`blog${blogs[0].blogId}`}
            className='img-fluid rounded-3 w-100'
        />
        <Icon icon="ri:focus-3-line" className='focus-icon '/>
            </div>
        <h1 className='blog-title pt-3 ' style={{ fontSize: '22px', fontWeight: '500' }}>
            {blogs[0].blogTitle}
        </h1>
        <p className='text-white'>
            {blogs[0].blogDescription.slice(0, 200)}...
        </p>
    </div>
)}

                {/* Secondary Blog Items */}
                <div className='col-lg-6 col-12'>
                    <div className='row'>
                        {blogs.slice(1, 3).map(blog => renderBlog(blog))}
                    </div>
                    <div className='row '>
                        {blogs.slice(3, 5).map(blog => renderBlog(blog))}
                    </div>
                </div>



            </div>
        </div>
        </section>
       

    );
}

export default Blogs;


